/* tslint:disable */

declare var Object: any;
export interface StorageAttachmentFileInterface {
  "id"?: number;
}

export class StorageAttachmentFile implements StorageAttachmentFileInterface {
  "id": number;
  constructor(data?: StorageAttachmentFileInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `StorageAttachmentFile`.
   */
  public static getModelName() {
    return "StorageAttachmentFile";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of StorageAttachmentFile for dynamic purposes.
  **/
  public static factory(data: StorageAttachmentFileInterface): StorageAttachmentFile{
    return new StorageAttachmentFile(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'StorageAttachmentFile',
      plural: 'StorageAttachmentFiles',
      path: 'StorageAttachmentFiles',
      idName: 'id',
      properties: {
        "id": {
          name: 'id',
          type: 'number'
        },
      },
      relations: {
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/shared/sdk/models/StorageAttachmentFile.ts